const splashLight = require('../assets/images/coinmend-splash-light.png');
const splashDark = require('../assets/images/coinmend-splash-dark.png');

const Images = {
  splashLight,
  splashDark,
};

export default Images;



// WEBPACK FOOTER //
// ./src/constants/Images.tsx